import type { SupportChatFeatureConfig } from './type';
import { SupportChatExternalAuthorizationMethod, SupportChatLanguage } from './type';

export const supportChat: Partial<SupportChatFeatureConfig> = {
    channelId: 'george-ebc-cc',
    externalAuthorizationMethod: SupportChatExternalAuthorizationMethod.TOKEN_EXCHANGE,
    externalAuthorizationTokenExchangeKeepAccessTokenInCookie: true,
    fallbackLanguage: SupportChatLanguage.HR,
    languagePackage: 'george-hr',
    supportedLanguages: [SupportChatLanguage.EN, SupportChatLanguage.HR, SupportChatLanguage.DE],
    useInvalidationWhenSessionExpired: true,
    displayChatStatus: true,
    proactiveChatChannelId: 'heygeorge-hr-web',
};
